import { Entity } from "../../state/helpers/Entity"



export type PaymentMethodDto = {
    id : string
}

export default class PaymentMethod implements Entity {
    private dto: PaymentMethodDto

    constructor(dto: PaymentMethodDto) {
        this.dto = dto
    }
    isLoaded(): boolean {
        return this.dto.id != ""
    }

    getId(): string {
        return this.dto.id
    }

}


// WEBPACK FOOTER //
// ./src/payment-account/model/paymentmethod.ts